import { render, staticRenderFns } from "./todoListTable.vue?vue&type=template&id=325c2608&"
import script from "./todoListTable.vue?vue&type=script&lang=ts&"
export * from "./todoListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports